<template>
  <div class="text" :style="textElStyles" v-html="text.text"></div>
</template>

<script>
export default {
  name: "BenefitUIText",
  props: {
    text: {
      type: Object,
      default() {},
    },
  },
  computed: {
    textElStyles() {
      const { textColor } = this.text;

      // direct styles
      const styles = {
        color: textColor.value,
      };
      return styles;
    },
  },
};
</script>

<style lang="scss" scoped>
.text {
  font-style: normal;
  hyphens: auto;
  text-align: center;
  overflow-wrap: anywhere;

  @include font-family("body");
  @include scale-fonts("body");
  @include setup-richtext();
}
</style>
